import commonStore from '../store/commonStore.js';

export const cv_openPageFromRendition = (url: string) => {
    const initialData = commonStore.getState().asyncStateReducer.initialData;
    const cv_url = 'cvopenhtml:' + initialData.html_origin + url;
    window.location.href = cv_url;
};
